import { Avatar, Spinner, Typography } from '@/components/common';
import AppRoutes from '@/const/routes';
import { Conversation, ConversationInfoTo } from '@/interfaces/inbox';
import clsx from 'clsx';
import { format, parseISO } from 'date-fns';
import Link from 'next/link';
import * as React from 'react';

interface MessageProps {
	date: string;
	firstname: string;
	lastname: string;
	profile_picture: string;
	me: boolean;
	message: string;
	clientTo?: ConversationInfoTo | undefined;
}

interface ConversationThreadProps {
	conversations?: Conversation[];
	containerRef: React.MutableRefObject<null>;
	clientTo?: ConversationInfoTo | undefined;
}

export const Message: React.FC<MessageProps> = ({
	date,
	firstname,
	lastname,
	profile_picture,
	message,
	me,
	clientTo,
}) => {
	return (
		<div
			className={clsx('flex flex-col w-full lg:min-h-[100px]', {
				'justify-end': me,
			})}
		>
			<div
				className={clsx(
					'hidden lg:flex items-center gap-x-2 mb-2 justify-end w-full',
					me ? '' : 'flex-row-reverse'
				)}
			>
				{me ? (
					<Typography type="semibold-14">You</Typography>
				) : clientTo?.id &&
				  clientTo.firstname === firstname &&
				  clientTo.lastname === lastname ? (
					<Link
						href={`${AppRoutes.LAWYERAPP_CLIENT_PROFILE}/${clientTo?.id}`}
						target="_blank"
					>
						<Typography type="semibold-14">
							{`${firstname} ${lastname}`}
						</Typography>
					</Link>
				) : (
					<Typography type="semibold-14">
						{`${firstname} ${lastname}`}
					</Typography>
				)}
				<Avatar
					size="extra-small"
					photoUrl={profile_picture}
					firstname={firstname}
					lastname={lastname}
				/>
			</div>
			<pre
				className={clsx(
					'p-3 whitespace-pre-wrap break-words !font-sans',
					me
						? 'bg-bg-primary rounded-s-2xl rounded-b-2xl'
						: 'bg-bg-white rounded-r-2xl rounded-b-2xl'
				)}
			>
				{message}
			</pre>
			<Typography
				type="regular-12"
				className={clsx('text-opacity-black mt-1', {
					'text-right': firstname,
				})}
			>
				{format(parseISO(date), 'MM/dd/yyyy, h:mm a')}
			</Typography>
		</div>
	);
};
export const ConversationThread: React.FC<ConversationThreadProps> = ({
	conversations,
	containerRef,
	clientTo,
}) => {
	return (
		<div
			ref={containerRef}
			className="overflow-hidden overflow-y-auto scroll-custom h-full mt-4"
		>
			<ul className="flex flex-col gap-4 h-full pr-2">
				{conversations ? (
					conversations.map((message, index) => (
						<li key={'message' + index}>
							<Message
								date={message.createdAt}
								firstname={message.firstname}
								lastname={message.lastname}
								profile_picture={message.profile_picture}
								me={message.me}
								message={message.content}
								clientTo={clientTo}
							/>
						</li>
					))
				) : (
					<div className="flex items-center justify-center w-full my-6">
						<Spinner type="loadingPage" />
					</div>
				)}
			</ul>
		</div>
	);
};
